<template>
  <div class="property-fee-container">


    <!-- 主费用信息组件 -->
    <view-main-fee ref="viewMainFee" :fee-name="$t('propertyFee.feeName')" fee-type-cd="888800010001"
      pay-name="propertyPay" />

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('propertyFee.paymentHistory') }}</span>
      </div>

      <el-row :gutter="20">
        <el-col :span="6">
          <el-date-picker v-model="feeDetailInfo.startTime" type="date" :placeholder="$t('propertyFee.selectStartTime')"
            style="width: 100%;" />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="feeDetailInfo.endTime" type="date" :placeholder="$t('propertyFee.selectEndTime')"
            style="width: 100%;" />
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="queryFeeDetailMethod()">
            <i class="el-icon-search"></i>
            {{ $t('propertyFee.searchNow') }}
          </el-button>
          <el-button type="info" @click="resetFeeDetailMethod()" style="margin-left: 20px;">
            <i class="el-icon-refresh"></i>
            {{ $t('propertyFee.reset') }}
          </el-button>
        </el-col>
      </el-row>

      <el-table :data="feeDetailInfo.feeDetails" style="width: 100%; margin-top: 20px;" border stripe>
        <el-table-column prop="detailId" :label="$t('propertyFee.paymentId')" align="center" />
        <el-table-column prop="cycles" :label="$t('propertyFee.cycle')" align="center" />
        <el-table-column prop="primeRateName" :label="$t('propertyFee.paymentMethod')" align="center" />
        <el-table-column :label="$t('propertyFee.receivableAmount')" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.state == '1500'">{{ scope.row.payerObjName }}{{ $t('propertyFee.viewInFee') }}</span>
            <span v-else>{{ scope.row.receivableAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('propertyFee.receivedAmount')" align="center">
          <template slot-scope="scope">
            {{ scope.row.receivedAmount }}<br>
            <div v-if="scope.row.acctAmount > 0">
              {{ $t('propertyFee.accountDeduction') }}: {{ scope.row.acctAmount }}<br>
            </div>
            <div v-for="(item, index) in scope.row.payFeeDetailDiscountDtoList" :key="index">
              {{ item.discountName }}: {{ Math.abs(item.discountPrice) }}<br>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('propertyFee.paymentTime')" align="center" />
        <el-table-column :label="$t('propertyFee.startTime')" align="center">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.startTime) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('propertyFee.endTime')" align="center">
          <template slot-scope="scope">
            {{ dateFormat(scope.row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="cashierName" :label="$t('propertyFee.cashier')" align="center" />
        <el-table-column prop="stateName" :label="$t('propertyFee.status')" align="center" />
        <el-table-column prop="remark" :label="$t('propertyFee.remark')" align="center" />
        <el-table-column :label="$t('propertyFee.operation')" align="center">
          <template slot-scope="scope">
            <el-button-group>
              <el-button v-if="scope.row.state == '1400' || scope.row.state == '1200' || scope.row.state == ''"
                size="mini" @click="_openRefundModel(scope.row)">
                {{ $t('propertyFee.applyRefund') }}
              </el-button>
              <el-button v-if="scope.row.state != '1500'" size="mini" @click="_openFeeDetailDiscountModal(scope.row)">
                {{ $t('propertyFee.discount') }}
              </el-button>
              <el-button size="mini" @click="_queryFaceThirdCallLogs(scope.row)">
                {{ $t('propertyFee.sync') }}
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top: 20px;" />
    </el-card>

    <!-- 子组件 -->
    <return-pay-fee ref="returnPayFee" @success="queryFeeDetailMethod" />
    <view-fee-detail-discount ref="viewFeeDetailDiscount" />

    <!-- 同步结果弹窗 -->
    <el-dialog :title="$t('propertyFee.syncResult')" :visible.sync="syncDialogVisible" width="80%" top="5vh">
      <div v-if="syncLoading" class="text-center" style="padding: 40px;">
        <i class="el-icon-loading" style="font-size: 24px;"></i>
        <div style="margin-top: 10px;">{{ $t('propertyFee.loading') }}</div>
      </div>
      <div v-else>
        <div v-if="syncLogs.length > 0">
          <el-table :data="syncLogs" border style="width: 100%">
            <el-table-column prop="logId" :label="$t('propertyFee.logId')" align="center" width="180" />
            <el-table-column prop="callTime" :label="$t('propertyFee.callTime')" align="center" width="160" />
            <el-table-column prop="communityName" :label="$t('propertyFee.communityName')" align="center" width="120" />
            <el-table-column prop="phone" :label="$t('propertyFee.phone')" align="center" width="120" />
            <el-table-column prop="serviceName" :label="$t('propertyFee.serviceName')" align="center" width="140" />
            <el-table-column :label="$t('propertyFee.status')" align="center" width="80">
              <template slot-scope="scope">
                <span :class="scope.row.status === 'SUCC' ? 'status-success' : 'status-error'">
                  {{ scope.row.status === 'SUCC' ? $t('propertyFee.success') : $t('propertyFee.failed') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="errorCode" :label="$t('propertyFee.errorCode')" align="center" width="120" />
            <el-table-column :label="$t('propertyFee.errorMsg')" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.errorMsg" class="error-msg-content">
                  <div v-for="(value, key) in parseErrorMsg(scope.row.errorMsg)" :key="key" class="error-msg-item">
                    <span class="error-msg-key">{{ getErrorMsgLabel(key) }}:</span>
                    <span class="error-msg-value">{{ value }}</span>
                  </div>
                </div>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="text-right" style="margin-top: 10px;">
            <el-pagination :current-page.sync="syncPage.current" :page-size="syncPage.size"
              :total="syncPage.total" layout="total, prev, pager, next"
              @current-change="handleSyncPageChange" />
          </div>
        </div>
        <div v-else class="text-center" style="padding: 40px; color: #999;">
          {{ $t('propertyFee.noData') }}
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryFeeDetail } from '@/api/fee/propertyFeeApi'
import { queryFaceThirdCallLogs } from '@/api/fee/feeDetailSyncApi'
import ViewMainFee from '@/components/fee/viewMainFee'
import ReturnPayFee from '@/components/fee/returnPayFee'
import ViewFeeDetailDiscount from '@/components/fee/viewFeeDetailDiscount'
import { dateFormat } from '@/utils/dateUtil'

export default {
  name: 'PropertyFeeList',
  components: {
    ViewMainFee,
    ReturnPayFee,
    ViewFeeDetailDiscount
  },
  data() {
    return {
      feeDetailInfo: {
        feeDetails: [],
        total: 0,
        records: 1,
        feeId: '',
        startTime: '',
        endTime: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      communityId: '',
      syncDialogVisible: false,
      syncLoading: false,
      syncLogs: [],
      syncPage: {
        current: 1,
        size: 10,
        total: 0
      },
      currentSyncDetailId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.feeDetailInfo.feeId = this.$route.query.feeId
    this.queryFeeDetailMethod()
  },
  methods: {
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    async listFeeDetail(page = 1, row = 10) {
      try {
        const params = {
          page,
          row,
          communityId: this.communityId,
          feeId: this.feeDetailInfo.feeId,
          startTime: this.feeDetailInfo.startTime,
          endTime: this.feeDetailInfo.endTime
        }

        const { feeDetails, total, records } = await queryFeeDetail(params)
        this.feeDetailInfo.feeDetails = feeDetails
        this.feeDetailInfo.total = total
        this.feeDetailInfo.records = records
        this.page.total = records
      } catch (error) {
        console.error('获取费用明细失败:', error)
      }
    },
    queryFeeDetailMethod() {
      this.page.current = 1
      this.listFeeDetail()
    },
    resetFeeDetailMethod() {
      this.feeDetailInfo.startTime = ''
      this.feeDetailInfo.endTime = ''
      this.queryFeeDetailMethod()
    },
    _openRefundModel(feeDetail) {
      this.$refs.returnPayFee.open(feeDetail)
    },
    _openFeeDetailDiscountModal(detail) {
      this.$refs.viewFeeDetailDiscount.open(detail)
    },
    async _queryFaceThirdCallLogs(row) {
      this.syncDialogVisible = true
      this.syncLoading = true
      this.currentSyncDetailId = row.detailId
      this.syncPage.current = 1
      try {
        const params = {
          page: this.syncPage.current,
          row: this.syncPage.size,
          communityId: this.communityId,
          detailId: row.detailId
        }
        const res = await queryFaceThirdCallLogs(params)
        this.syncLogs = res.data || []
        this.syncPage.total = res.count || 0
      } catch (error) {
        console.error('查询同步日志失败:', error)
        this.syncLogs = []
        this.syncPage.total = 0
      } finally {
        this.syncLoading = false
      }
    },
    async handleSyncPageChange(page) {
      this.syncPage.current = page
      this.syncLoading = true
      try {
        const params = {
          page: this.syncPage.current,
          row: this.syncPage.size,
          communityId: this.communityId,
          feeId: this.feeDetailInfo.feeId,
          detailId: this.currentSyncDetailId
        }
        const res = await queryFaceThirdCallLogs(params)
        this.syncLogs = res.data || []
        this.syncPage.total = res.count || 0
      } catch (error) {
        console.error('查询同步日志失败:', error)
      } finally {
        this.syncLoading = false
      }
    },
    parseErrorMsg(errorMsg) {
      if (!errorMsg) return {}
      try {
        const obj = typeof errorMsg === 'string' ? JSON.parse(errorMsg) : errorMsg
        return obj
      } catch (e) {
        return { message: errorMsg }
      }
    },
    getErrorMsgLabel(key) {
      const labels = {
        houseId: '房屋ID',
        newExpiredDate: '新过期时间',
        phone: '手机号',
        enable: '是否启用',
        faceId: '人脸ID',
        currentExpiredDate: '当前过期时间',
        error: '错误信息',
        detailId: '明细ID',
        carNum: '车牌号',
        errorCode: '错误码',
        cycles: '周期',
        endTime: '结束时间',
        message: '消息',
        callType: '调用类型',
        status: '状态'
      }
      return labels[key] || key
    },
    handleSizeChange(val) {
      this.page.size = val
      this.listFeeDetail(this.page.current, val)
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.listFeeDetail(val, this.page.size)
    }
  }
}
</script>

<style lang="scss" scoped>
.property-fee-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .clearfix {
    font-size: 18px;
    font-weight: bold;
  }
}

.status-success {
  color: #67c23a;
  font-weight: 500;
}

.status-error {
  color: #f56c6c;
  font-weight: 500;
}

.text-center {
  text-align: center;
}

.error-msg-content {
  text-align: left;
  font-size: 13px;

  .error-msg-item {
    line-height: 1.8;
    display: flex;
    flex-wrap: wrap;
  }

  .error-msg-key {
    color: #606266;
    margin-right: 6px;
    white-space: nowrap;
  }

  .error-msg-value {
    color: #303133;
    word-break: break-all;
  }
}
</style>